import React from 'react';
import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { MathUtils } from '@/domain/utils/mathUtils';
import { qaAttr, type QaAttrOptions } from '@/presentation/utils/qaAttr';

export interface UserDetailsStatColumnProps {
  value: number | undefined;
  label: string;
  /** Optional `data-qa-*` set spread onto the stat container so the qa-tester can locate it. */
  qa?: QaAttrOptions;
}

export const UserDetailsStatColumn: React.FC<UserDetailsStatColumnProps> = ({ value, label, qa }) => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();

  return (
    <div
      {...(qa ? qaAttr(qa) : {})}
      className="flex flex-col items-center"
      style={{ gap: responsive.gap.xs }}
    >
      <span
        style={{
          color: theme.text.primary,
          fontSize: responsive.font.lg,
          fontWeight: responsive.fontWeight.bold,
          textAlign: 'center',
        }}
      >
        {value === undefined ? '-' : MathUtils.formatCount(value)}
      </span>
      <span
        style={{
          color: theme.text.secondary,
          fontSize: responsive.font.sm,
          textAlign: 'center',
        }}
      >
        {label}
      </span>
    </div>
  );
};
